"use client"

import { useState } from "react"
import {
  CalculatorCard,
  CalculatorGrid,
  FormulaNote,
  NumberField,
  ResultStat,
  formatMultiple,
  formatPercent,
  parseNum,
} from "./calculator-ui"

/**
 * MER (Marketing Efficiency Ratio) = total revenue ÷ total marketing spend.
 * Unlike ROAS (per-channel, attributed), MER is blended across every channel.
 * Default example: $120,000 revenue ÷ $30,000 spend = 4× MER.
 */
export function BlendedMerWidget() {
  const [revenue, setRevenue] = useState("120000")
  const [spend, setSpend] = useState("30000")

  const rev = parseNum(revenue)
  const sp = parseNum(spend)
  const mer = rev !== null && sp !== null && sp > 0 ? rev / sp : NaN
  const spendShare = Number.isFinite(mer) ? 1 / mer : NaN

  return (
    <CalculatorCard title="Blended MER Calculator">
      <CalculatorGrid>
        <NumberField
          id="mer-revenue"
          label="Total revenue"
          value={revenue}
          onChange={setRevenue}
          prefix="$"
          hint="All revenue in the period, every channel."
        />
        <NumberField
          id="mer-spend"
          label="Total marketing spend"
          value={spend}
          onChange={setSpend}
          prefix="$"
          hint="All paid media + marketing costs."
        />
      </CalculatorGrid>

      <div className="mt-6">
        <ResultStat
          label="Marketing Efficiency Ratio"
          value={formatMultiple(mer)}
          tone={Number.isFinite(mer) ? (mer >= 1 ? "good" : "bad") : "neutral"}
          caption={
            Number.isFinite(mer)
              ? `Total revenue is ${formatMultiple(mer)} your total marketing spend. Marketing is ${formatPercent(spendShare)} of revenue.`
              : "Enter total revenue and a non-zero spend."
          }
        />
      </div>

      <FormulaNote>MER = Total revenue ÷ Total marketing spend. Blended across all channels, so it captures halo effects ROAS misses.</FormulaNote>
    </CalculatorCard>
  )
}
